import type { StudyApiId } from '@/model/Study.model';
import {
  type BenchlingBackfillApiId,
  type BenchlingBackfillEntityType,
  type BenchlingBackfillEventApiId,
  type BenchlingSyncEventApiId,
} from '@/model/BenchlingBackfill.model.ts';

export const SyncEntityContext = {
  BACKFILL_EVENTS: 'backfill-events',
  SYNC_EVENTS: 'sync-events',
  STUDY_SYNC_EVENTS: 'study-sync-events',
} as const;
export type SyncEntityContext = (typeof SyncEntityContext)[keyof typeof SyncEntityContext];

export interface BackfillEventsSyncEntityRequestProps {
  context: typeof SyncEntityContext.BACKFILL_EVENTS;
  backfillApiId: BenchlingBackfillApiId;
  backfillEventApiId: BenchlingBackfillEventApiId;
}

export interface SyncEventsSyncEntityRequestProps {
  context: typeof SyncEntityContext.SYNC_EVENTS;
  syncEventApiId: BenchlingSyncEventApiId;
}

export interface StudySyncEventsSyncEntityRequestProps {
  context: typeof SyncEntityContext.STUDY_SYNC_EVENTS;
  studyApiId: StudyApiId;
  syncEventApiId: BenchlingSyncEventApiId;
}

export type SyncEntityRequestProps =
  | BackfillEventsSyncEntityRequestProps
  | SyncEventsSyncEntityRequestProps
  | StudySyncEventsSyncEntityRequestProps;

export interface SyncEntityDetailsProps {
  syncEntityRequestProps: SyncEntityRequestProps;
  entityType: BenchlingBackfillEntityType;
  closeModal: () => void;
}
